import React, { useEffect, useState } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
// import { zoomPlugin } from "@react-pdf-viewer/zoom";
// import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation";
import { printPlugin } from "@react-pdf-viewer/print";
import { highlightPlugin, Trigger } from "@react-pdf-viewer/highlight";
import "@react-pdf-viewer/zoom/lib/styles/index.css";
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import "@react-pdf-viewer/search/lib/styles/index.css";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/highlight/lib/styles/index.css";
// Import styles
import "@react-pdf-viewer/print/lib/styles/index.css";
import "./index.css";
import CircularProgressWithLabel from "../CircularProgressWithLabel";
import { getFilePlugin } from "@react-pdf-viewer/get-file";

function PDFView({
  source = { page: null, coordinates: null, coordinate_list: [] },
  file,
  scale = 1,
  handlePagesChange,
  zoomPluginInstance,
  pageNavigationPluginInstance,
  printPluginInstance = printPlugin(),
  getFilePluginInstance = getFilePlugin(),
  setCurrentPage,
}) {
  let { page, coordinates, coordinate_list } = source;

  if (page > 0) {
    page = page - 1;
  }
  const [isFileLoading, setIsFileLoading] = useState(true);
  const { jumpToPage } = pageNavigationPluginInstance;
  const [areas, setAreas] = useState([]);

  const pageLayout = {
    transformSize: ({ size }) => ({
      height: size.height + 8,
      width: size.width + 8,
    }),
  };

  // Reset loading state whenever file changes so we can jump after load
  useEffect(() => {
    setIsFileLoading(true);
  }, [file]);

  useEffect(() => {
    if (page !== null && page !== undefined) {
      if (Array.isArray(coordinate_list) && coordinate_list.length > 0) {
        try {
          const areasFromList = coordinate_list
            .filter((s) => typeof s === "string" && s.length > 0)
            .map((area) => {
              const parsed = area
                .split(",")
                .map((n) => parseFloat(String(n).trim()));
              return {
                pageIndex: page,
                height: parsed[3],
                width: parsed[2],
                left: parsed[0],
                top: parsed[1],
              };
            });
          setAreas(areasFromList);
        } catch (error) {
          console.log(error);
        }
      } else if (coordinates) {
        let parsedCoordinates = [5, 5, 90, 90];
        try {
          parsedCoordinates = coordinates
            .split(",")
            .map((coord) => parseFloat(coord.trim()));
        } catch (error) {
          console.log(error);
        }
        setAreas([
          {
            pageIndex: page,
            height: parsedCoordinates[3],
            width: parsedCoordinates[2],
            left: parsedCoordinates[0],
            top: parsedCoordinates[1],
          },
        ]);
      } else {
        setAreas([]);
      }
    }

    // Only jump after the document has finished loading
    if (!isFileLoading && page !== null && page !== undefined) {
      jumpToPage(page);
    }
  }, [isFileLoading, page, file, source]);

  const renderHighlights = (props) => (
    <div>
      {areas
        .filter((area) => area.pageIndex === props.pageIndex)
        .map((area, idx) => (
          <div
            key={idx}
            className="highlight-area"
            style={Object.assign(
              {},
              {
                background: "#b4d7ff",
                opacity: 0.3,
              },
              props.getCssProperties(area, props.rotation)
            )}
          />
        ))}
    </div>
  );

  const highlightPluginInstance = highlightPlugin({
    renderHighlights,
    trigger: Trigger.None,
  });

  const handleDocumentLoad = (e) => {
    if (handlePagesChange) handlePagesChange(e.doc.numPages);
    setIsFileLoading(false);
  };

  const onPageChange = (e) => {
    const { currentPage } = e;
    if (setCurrentPage) {
      setCurrentPage(currentPage);
    }
  };

  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
      <Viewer
        // onPageChange={onPageChange}
        onDocumentLoad={handleDocumentLoad}
        plugins={[
          highlightPluginInstance,
          pageNavigationPluginInstance,
          zoomPluginInstance,
          printPluginInstance,
          getFilePluginInstance,
        ]}
        defaultScale={scale}
        fileUrl={file["file_url"]}
        pageLayout={pageLayout}
        renderLoader={(percentages) => (
          <CircularProgressWithLabel value={Math.round(percentages)} />
        )}
      />
    </Worker>
  );
}

export default PDFView;
